(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat-banner/assets/javascripts/bannerprops-handler.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat-banner/assets/javascripts/bannerprops-handler.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const logger = svs.core.log.getLogger('sport:sportinfo-bigstat');
const _svs$components$sport = svs.components.sportinfo.common.constants,
  OutcomeToAlphabeticStrings = _svs$components$sport.OutcomeToAlphabeticStrings,
  EventTypes = _svs$components$sport.EventTypes;
const _svs$components$sport2 = svs.components.sport.sportEventCommon,
  ResultTypes = _svs$components$sport2.ResultTypes,
  helpers = _svs$components$sport2.helpers;
const ApiProxy = svs.components.lbUtils.apiProxy.ApiProxy;
const _svs$components$sport3 = svs.components.sportinfo.common.helpers,
  customSporteventApiHandler = _svs$components$sport3.customSporteventApiHandler,
  customSporteventOddsApiHandler = _svs$components$sport3.customSporteventOddsApiHandler;
const BannerpropsHandler = _ref => {
  let matchId = _ref.matchId,
    productId = _ref.productId,
    children = _ref.children;
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    bannerprops = _useState4[0],
    setBannerprops = _useState4[1];
  useEffect(() => {
    let isActive = true;
    setIsLoading(true);
    const apiProxySportEvent = new ApiProxy([customSporteventApiHandler]);
    const apiProxySportEventOdds = new ApiProxy([customSporteventOddsApiHandler]);
    (async () => {
      try {
        const eventPromise = apiProxySportEvent.fetch("/sport/1/sportevent/".concat(matchId), {
          method: 'GET',
          productId
        });
        const oddsPromise = apiProxySportEventOdds.fetch("/sport/2/sportevent/".concat(matchId, "/odds"), {
          method: 'GET',
          productId
        });
        const _await$Promise$all = await Promise.all([eventPromise, oddsPromise]),
          _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
          eventResponse = _await$Promise$all2[0],
          oddsResponse = _await$Promise$all2[1];
        if (eventResponse) {
          const _eventResponse$sportE = eventResponse.sportEvent,
            participants = _eventResponse$sportE.participants,
            league = _eventResponse$sportE.league,
            sport = _eventResponse$sportE.sport,
            startTime = _eventResponse$sportE.startTime,
            results = _eventResponse$sportE.results,
            sportEventStatus = _eventResponse$sportE.status,
            statusTime = _eventResponse$sportE.statusTime;
          let odds = null;
          if (oddsResponse) {
            const oddsType = oddsResponse.eventTypes.find(et => et.eventType === EventTypes.EventType1X2);
            const oddsToParse = oddsType !== null && oddsType !== void 0 && oddsType.odds.length ? oddsType === null || oddsType === void 0 ? void 0 : oddsType.odds : oddsType === null || oddsType === void 0 ? void 0 : oddsType.startOdds;
            if (oddsToParse !== null && oddsToParse !== void 0 && oddsToParse.length) {
              odds = oddsToParse.reduce((acc, curr) => {
                acc[OutcomeToAlphabeticStrings[curr.outcome]] = curr.value;
                return acc;
              }, {});
            }
          }
          if (isActive) {
            setBannerprops({
              homeTeam: participants[0],
              awayTeam: participants[1],
              leagueName: league.name,
              sportType: sport.sportType,
              startTime,
              results: helpers.getCurrentResult(results) || results.find(result => result.type === ResultTypes.Fulltime),
              odds,
              sportEventStatus,
              statusTime
            });
          }
        }
        if (isActive) {
          setIsLoading(false);
        }
      } catch (error) {
        logger.warn("Failed to fetch match with id ".concat(matchId, ": ").concat(error));
        if (isActive) {
          setIsLoading(false);
        }
      }
    })();
    return () => {
      isActive = false;
    };
  }, [matchId, productId]);
  return children(bannerprops, isLoading);
};
BannerpropsHandler.propTypes = {
  children: PropTypes.func.isRequired,
  matchId: PropTypes.number.isRequired
};
setGlobal('svs.components.sportInfo.bigStatBanner.BannerpropsHandler', BannerpropsHandler);

 })(window);